/** Full expanded width of the sidebar drawer */
export const NAV_DRAWER_WIDTH = 225;

/** Width of the icon column (theme.spacing(8) + 1px ≈ 60px) */
export const ICON_COL_WIDTH = 60;

/** Available width for text labels */
export const TEXT_WIDTH = NAV_DRAWER_WIDTH - ICON_COL_WIDTH;

/** Height of each sidebar nav item */
export const ITEM_HEIGHT = 47;
